import React from "react";

const PageHeader = ({ description, children }) => {
  if (!description && !children) {
    return null;
  }

  return (
    <div className="flex items-center justify-between mb-6">
      {description && <p className="ui-subtitle">{description}</p>}
      {!description && <div />}
      {children && (
        <div className="flex items-center gap-3 shrink-0">{children}</div>
      )}
    </div>
  );
};

export default PageHeader;
